import React from "react";
import "./PartnerSection.css";

import partner1 from "../images/DEAfrica.png";               
import partner2 from "../images/esri.png";
import helmsleyLogo from "../images/hemsley.jpg";

const logos = [partner1, partner2]; // Add more as needed

const PartnerSection = () => {
  return (
    <div className="partner-section">
      <h2 className="partner-title">Our Partners</h2>

      <p className="partner-support">With generous support from:</p>
      <div className="helmsley-logo">
        <img src={helmsleyLogo} alt="Helmsley Charitable Trust" />
      </div>
     <div className="marquee">
  <div className="marquee-track">
    {logos.map((logo, index) => (
      <img src={logo} alt={`Partner ${index}`} key={index} />
    ))}
  </div>
</div>


    </div>
  );
};

export default PartnerSection;
